import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=33853036&scoped=true"
import script from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmptyState.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./wellness-base.css?vue&type=style&index=0&id=33853036&prod&scoped=true&lang=css&external"
import style1 from "./EmptyState.vue?vue&type=style&index=1&id=33853036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33853036",
  null
  
)

export default component.exports